// TODO: Check permissions inside of the route config, and simply don't bind routes that shouldn't be available.
//  We'll still need of a separate awy to check permissions, as we might need to hide some elements on certain pages.
export const DELEGATION_RULES_CRUD = 'workflows:delegation-rules:crud'
export const SESSION_DELETE = 'workflows:session:delete'
export const SESSION_READ = 'workflows:session:read'
export const SESSION_WRITE = 'workflows:session:write'
export const TASK_DELETE = 'workflows:task:delete'
export const TASK_READ = 'workflows:task:read'
export const TASK_OVERRULE = 'workflows:task:overrule'
export const TASK_UPDATE = 'workflows:task:update'
export const WEB_UI_LOGIN = 'workflows:webui:login'
export const WORKFLOW_DELETE = 'workflows:workflow:delete'
export const WORKFLOW_READ = 'workflows:workflow:read'
export const WORKFLOW_WRITE = 'workflows:workflow:write'

export function isAllowed(context, permission) {
    const { permissions } = context
    return permissions.indexOf(permission) !== -1
}

export function isAnyAllowed(context, permissions) {
    return permissions.some(
        permission => context.permissions.indexOf(permission) !== -1
    )
}

export function workflowWriteIsAllowed(context) {
    return isAnyAllowed(context, [WORKFLOW_WRITE])
}

export function isGlobalAdmin(context) {
    return context.data.is_global_admin
}
